<div *ngIf='screenWidth > 1230'>
<div (window:orientationchange)="screenRotate($event)">
<div class="container-fluid bmw-no-gutter">
  <div class="bmw-lg-results-topbar">
    <div class="row bmw-no-gutter">
      <div class="col-lg-3">
        {{results_count}} results
        <span *ngIf="search_key">
                for "<label style="font-weight:bold;color:#1c69d4">
                {{search_key.length>25 ? search_key.substring(0,21)+'...' : search_key}}
              </label>"
            </span>
      </div>
      <div class="col-lg-6">
        <div class="col-lg-7 bmw-no-gutter">
          <div class="col-lg-4 bmw-no-gutter">
            Results per page
          </div>
          <div class="col-lg-6 bmw-no-gutter">
            <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===5?"#1c69d4":"#333"' (click)='updateResultsLimit(5)'>5</a>
            <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===10?"#1c69d4":"#333"' (click)='updateResultsLimit(10)'>10</a>
            <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===15?"#1c69d4":"#333"' (click)='updateResultsLimit(15)'>15</a>
          </div>
        </div>
        <div class="col-lg-7"></div>
      </div>
      <div class="col-lg-3">
        <div class="col-lg-4 bmw-no-gutter" style="text-align:right">
        </div>
        <div class="col-lg-8">
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-2 bmw-no-gutter bmw-lg-results-side-bar">
    <app-results-side-bar></app-results-side-bar>
  </div>
  <div class="col-lg-8 bmw-no-gutter bmw-lg-results-content">
    <app-results-content (resultsCount)='resultCountChange($event)' [resultsLimit]="resultsLimit" ></app-results-content>
    <div class="bmw-lg-results-content-pagination">
    </div>
  </div>
</div>
</div>
</div>
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
<div (window:orientationchange)="screenRotate($event)">
<div class="container-fluid bmw-no-gutter">
  <div class="bmw-md-results-topbar">
    <div class="row bmw-no-gutter">
      <div class="col-md-3">
        {{results_count}} results
        <span *ngIf="search_key">
                  for "<label style="font-weight:bold;color:#1c69d4">
                  {{search_key.length>25 ? search_key.substring(0,21)+'...' : search_key}}
                </label>"
              </span>
      </div>
      <div class="col-md-6 bmw-no-gutter">
        <div class="col-md-9 bmw-no-gutter">
          <div class="col-md-4 bmw-no-gutter">
            Results per page
          </div>
          <div class="col-md-6 bmw-no-gutter">
            <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===5?"#1c69d4":"#333"' (click)='updateResultsLimit(5)'>5</a>
            <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===10?"#1c69d4":"#333"' (click)='updateResultsLimit(10)'>10</a>
            <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===15?"#1c69d4":"#333"' (click)='updateResultsLimit(15)'>15</a>
          </div>
        </div>
        <div class="col-md-3"></div>
      </div>
      <div class="col-md-3">
        <div class="col-md-4 bmw-no-gutter" style="text-align:right">
        </div>
        <div class="col-md-8">
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-2 bmw-no-gutter bmw-lg-results-side-bar">
    <app-results-side-bar></app-results-side-bar>
  </div>
  <div class="col-md-10 bmw-no-gutter bmw-lg-results-content">
      <app-results-content (resultsCount)='resultCountChange($event)' [resultsLimit]="resultsLimit" ></app-results-content>
    <div class="bmw-lg-results-content-pagination">
    </div>
  </div>
</div>
</div>
</div>
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
<div (window:orientationchange)="screenRotate($event)">
<div class="row bmw-no-gutter bmw-xs-results-header" style="margin-left:-15px;margin-right:-15px">
  <div class="col-sm-11 bmw-no-gutter" [class.activeLink]='section==="all"' style="padding-top:1%;padding-bottom:2%;"><a (click)='sendSelectedSectionToHeader("All")' [routerLink]="['/results', 'all']">ALL</a></div>
  <div class="col-sm-11 bmw-no-gutter" [class.activeLink]='section==="sib"' style="padding-bottom:1%"><a (click)='sendSelectedSectionToHeader("SIB")' [routerLink]="['/results', 'sib']">SERVICE BULLETINS</a></div>
  <div class="col-sm-11 bmw-no-gutter" [class.activeLink]='section==="pbs"' style="padding-bottom:1%"><a (click)='sendSelectedSectionToHeader("PBS")' [routerLink]="['/results', 'pbs']">PARTS BULLETINS</a></div>
  <div class="col-sm-11 bmw-no-gutter" [class.activeLink]='section==="of"' style="padding-bottom:1%"><a (click)='sendSelectedSectionToHeader("OF")' [routerLink]="['/results', 'of']">OPERATING FLUIDS</a></div>
  <div class="col-sm-11 bmw-no-gutter" [class.activeLink]='section==="tm"' style="padding-bottom:1%"><a (click)='sendSelectedSectionToHeader("TM")' [routerLink]="['/results', 'tm']">TRAINING MANUALS</a></div>
  <div class="col-sm-11 bmw-no-gutter" [class.activeLink]='section==="noi"' style="padding-top:1%;padding-bottom:2%;"><a (click)='sendSelectedSectionToHeader("NOI")' [routerLink]="['/results', 'noi']">Noise Catalog</a></div>
  <div class="col-sm-11 bmw-no-gutter" [class.activeLink]='section==="vid"' style="padding-top:1%;padding-bottom:2%;"><a (click)='sendSelectedSectionToHeader("VID")' [routerLink]="['/results', 'vid']">VIDEOS</a></div>
  <div class="col-sm-11 bmw-no-gutter" [class.activeLink]='section==="obd"' style="padding-top:1%;padding-bottom:2%;"><a (click)='sendSelectedSectionToHeader("OBD")' [routerLink]="['/results', 'obd']">OBD</a></div>
  <div class="dropdown">
    <div class="col-sm-1 bmw-no-gutter dropdown-toggle" data-toggle="dropdown" style="padding-bottom:2%;padding-top:1%" [class.activeLink]='select_more_sm'><a>MORE</a></div>
    <ul class="dropdown-menu bmw-dropdown-background bmw-sm-dropdown" style="width:300px">
      <li>

        <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('TE');sendSelectedSectionToHeader('TE')">
          <div class="col-sm-10">Tools & Equipment (T&E)</div>
          <div class="col-sm-2"><input type="radio" value="te"> </div>
        </div>

      </li>
      <li>

        <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('TD');sendSelectedSectionToHeader('TD')">
          <div class="col-sm-10">Technical Documentation (TD)</div>
          <div class="col-sm-2"><input type="radio" value="td"> </div>
        </div>

      </li>
      <li>

        <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('TKR');sendSelectedSectionToHeader('TKR')">
          <div class="col-sm-10">Takata Recall (TKR)</div>
          <div class="col-sm-2"><input type="radio" value="tkr"> </div>
        </div>

      </li>
      <li>

        <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('LGC');sendSelectedSectionToHeader('LGC')">
          <div class="col-sm-10">Legacy (LGC)</div>
          <div class="col-sm-2"><input type="radio" value="lgc"> </div>
        </div>

      </li>
    </ul>
  </div>
</div>
<div class="row bmw-no-gutter" style="background-color:#fff;margin-left:-15px;margin-right:-15px;padding-top:3%;font-size:14px">
  <div class="col-sm-8 bmw-align-text-left">
    {{results_count}} results
    <span *ngIf="search_key">
                  for "<label style="font-weight:bold;color:#1c69d4">
                  {{search_key.length>25 ? search_key.substring(0,21)+'...' : search_key}}
                </label>"
              </span>
  </div>
  <div class="col-sm-4 bmw-xs-results-filter-label">
    <div class="col-sm-6 bmw-no-gutter"></div>
    <div data-toggle="modal" data-target="#filterModal">
      <div class="col-sm-3 bmw-no-gutter bmw-align-text-right">
        <i class="material-icons dp48" style="font-size:20px">filter_list</i>
      </div>
      <div class="col-sm-3 bmw-no-gutter">
        Filter
      </div>
    </div>
    <div class="modal fade bmw-sm-results-modal" id="filterModal" role="dialog">
      <div class="modal-dialog">

        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Main Group</div>
              <div class="row bmw-no-gutter">
                <select [(ngModel)]='filter.group' [disabled]='!(section==="sib" || section==="tri" || section==="all")'>
                    <option *ngFor='let group of mainGroupList' [ngValue]='group'>{{group}}</option>
                    </select>
                    <span style="color:#d20000">{{noMainGroupError}}</span>
              </div>
            </div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Series</div>
              <div class="row bmw-no-gutter">
                <input [(ngModel)]='filter.series' type="input" placeholder="Enter Series" style="width:40%" [disabled]='!(section==="sib" || section==="tri" || section==="all")'>
              </div>
            </div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Year Published</div>
              <div class="row bmw-no-gutter">
                <div class="row bmw-no-gutter">
                  <div class="col-sm-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    From
                  </div>
                  <div class="col-sm-7 bmw-no-gutter bmw-width-30-percent">

                    <select #selectFrom [(ngModel)]='filter.from' [disabled]='(section==="of" || section==="te" || section==="tm" || section==="td"|| section==="lgc")'>
                        <option *ngFor="let year of fromYears" [ngValue]="year">{{year}}</option>
                      </select>
                      <span style="color:#d20000">{{noFromYear}}</span>
                  </div>

                </div>
                <div class="row bmw-no-gutter" style="margin-top:10px">
                  <div class="col-sm-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    To
                  </div>
                  <div class="col-sm-7 bmw-no-gutter bmw-width-30-percent">
                    <select [(ngModel)]='filter.to' [disabled]='(section==="of" || section==="te" || section==="tm" || section==="td"|| section==="lgc")'>
                          <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                        </select>
                        <span style="color:#d20000">{{noToYear}}</span>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-sm-6">
                <button type="button" class="bmw-sm-results-btn-clear-filter" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' (click)='clearFilter()' style="margin-right:34%;">Clear Filter</button>
              </div>
              <div class="col-sm-6">
                <button type="button" class="bmw-sm-results-btn-apply-filter" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' style="margin-right:34%" (click)='applyFilter()'>Apply Filter</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="row bmw-no-gutter bmw-xs-results-label">
  <div class="col-sm-3 bmw-align-text-left" style="margin-right:-30px; padding-right:0px">
    Results per page
  </div>
  <div class="col-sm-9 bmw-no-gutter bmw-align-text-left">
    <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===5?"#1c69d4":"#333"' (click)='updateResultsLimit(5)'>5</a>
    <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===10?"#1c69d4":"#333"' (click)='updateResultsLimit(10)'>10</a>
    <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===15?"#1c69d4":"#333"' (click)='updateResultsLimit(15)'>15</a>
  </div>
</div>
<app-results-content (resultsCount)='resultCountChange($event)' [resultsLimit]="resultsLimit" ></app-results-content>
</div>
</div>

<div *ngIf='screenWidth >= 0 && screenWidth <= 766'>
    <div (window:orientationchange)="screenRotate($event)">
        <div class="row bmw-no-gutter bmw-xs-results-header" style="margin-left:-15px;margin-right:-15px">
          <div class="col-xs-1 bmw-no-gutter" style="margin-left:15px;padding-top:2%;padding-bottom:4%;" [class.activeLink]='section==="all"'><a (click)='sendSelectedSectionToHeader("All")' [routerLink]="['/results', 'all']">ALL</a></div>
          <div class="col-xs-1 bmw-margin-right"></div>
          <div class="col-xs-2 bmw-no-gutter" [class.activeLink]='section==="sib"'><a (click)='sendSelectedSectionToHeader("SIB")' [routerLink]="['/results', 'sib']">SERVICE BULLETINS</a></div>
-->        <div class="col-xs-1 bmw-margin-right"></div>
          <div class="col-xs-2 bmw-no-gutter" [class.activeLink]='section==="pbs"'><a (click)='sendSelectedSectionToHeader("PBS")' [routerLink]="['/results', 'pbs']">PARTS BULLETINS</a></div>
          <div class="col-xs-1 bmw-margin-right"></div>
          <div class="dropdown">
              <div class="col-xs-1 bmw-no-gutter dropdown-toggle" data-toggle="dropdown" style="padding-bottom:4%;padding-top:2%" [class.activeLink]='select_more_xs'><a>MORE</a></div>
              <ul class="dropdown-menu bmw-dropdown-background bmw-xs-dropdown" style="width:236px">
                <li>
        
                  <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('TM');sendSelectedSectionToHeader('TM')">
                    <div class="col-xs-10">Training Manuals (TM)</div>
                    <div class="col-xs-2"><input type="radio" value="tm"> </div>
                  </div>
        
                </li>
                <li>
        
                  <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('NOI');sendSelectedSectionToHeader('NOI')">
                    <div class="col-xs-10">Noise Catalog (NOI)</div>
                    <div class="col-xs-2"><input type="radio" value="noi"> </div>
                  </div>
        
                </li>
                <li>
                  <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('VID');sendSelectedSectionToHeader('VID')">
                    <div class="col-xs-10">Videos (VID)</div>
                    <div class="col-xs-2"><input type="radio" value="vid"> </div>
                  </div>
        
                </li>
                <li>
        
                  <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('OBD');sendSelectedSectionToHeader('OBD')">
                    <div class="col-xs-10">OBD</div>
                    <div class="col-xs-2"><input type="radio" value="obd"> </div>
                  </div>
        
                </li>
                <li>
        
                  <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('TE');sendSelectedSectionToHeader('TE')">
                    <div class="col-xs-10">Tools & Equipment (T&E)</div>
                    <div class="col-xs-2"><input type="radio" value="te"> </div>
                  </div>
        
                </li>
                <li>
        
                  <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('TD');sendSelectedSectionToHeader('TD')">
                    <div class="col-xs-10">Technical Documentation (TD)</div>
                    <div class="col-xs-2"><input type="radio" value="td"> </div>
                  </div>
        
                </li>
                <li>
        
                  <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('TKR');sendSelectedSectionToHeader('TKR')">
                    <div class="col-xs-10">Takata Recall (TKR)</div>
                    <div class="col-xs-2"><input type="radio" value="tkr"> </div>
                  </div>
        
                </li>
                <li>
        
                  <div class="pointer bmw-xs-dropdown-radio" (click)="selectValue('LGC');sendSelectedSectionToHeader('LGC')">
                    <div class="col-xs-10">Legacy (LGC)</div>
                    <div class="col-xs-2"><input type="radio" value="lgc"> </div>
                  </div>
        
                </li>
              </ul>
            </div>
          </div>
<div class="row bmw-no-gutter" style="background-color:#fff; margin-left:-15px; margin-right:-15px; padding-top:3%;">
  <div class="col-xs-8 bmw-align-text-left">
    {{ results_count }} results
    <span *ngIf="search_key">
                  for "<label style="font-weight:bold;color:#1c69d4">
                  {{ search_key.length>25 ? search_key.substring(0,21)+'...' : search_key }}
                </label>"
              </span>
  </div>
  <div class="col-xs-4 bmw-xs-results-filter-label">
    <div class="col-xs-6 bmw-no-gutter"></div>
    <div data-toggle="modal" data-target="#filterModal">
      <div class="col-xs-3 bmw-no-gutter bmw-align-text-right">
        <i class="material-icons dp48" style="font-size:20px">filter_list</i>
      </div>
      <div class="col-xs-3 bmw-no-gutter">
        Filter
      </div>
    </div>
    <div class="modal fade" id="filterModal" role="dialog">
      <div class="modal-dialog" style="width: 93%;">

        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:white">&times;</button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Main Group</div>
              <div class="row bmw-no-gutter">
                <select #selectGroup [(ngModel)]='filter.group' [disabled]='!(section==="sib" || section==="tri" || section==="all")'>
                    <option *ngFor='let group of mainGroupList' [ngValue]='group'>{{group}}</option>
                    </select>
                    <span style="color:#d20000">{{noMainGroupError}}</span>
              </div>
            </div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Series</div>
              <div class="row bmw-no-gutter">
                <input [(ngModel)]='filter.series' type="input" placeholder="Enter Series" style="width:40%" [disabled]='!(section==="sib" || section==="tri" || section==="all")'>
              </div>
            </div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter">Year Published</div>
              <div class="row bmw-no-gutter">
                <div class="row bmw-no-gutter">
                  <div class="col-sm-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    From
                  </div>
                  <div class="col-sm-7 bmw-no-gutter bmw-width-30-percent">

                    <select #selectFrom [(ngModel)]='filter.from' [disabled]='(section==="of" || section==="te" || section==="tm" || section==="td"|| section==="lgc")'>
                        <option *ngFor="let year of fromYears" [ngValue]="year">{{year}}</option>
                      </select>
                      <span style="color:#d20000">{{noFromYear}}</span>
                  </div>

                </div>
                <div class="row bmw-no-gutter" style="margin-top:10px">
                  <div class="col-sm-4 bmw-no-gutter bmw-xs-results-filter-year-label">
                    To
                  </div>
                  <div class="col-sm-7 bmw-no-gutter bmw-width-30-percent">
                    <select [(ngModel)]='filter.to' [disabled]='(section==="of" || section==="te" || section==="tm" || section==="td"|| section==="lgc")'>
                          <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
                        </select>
                        <span style="color:#d20000">{{noToYear}}</span>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
            <div class="row bmw-no-gutter">
              <div class="col-xs-6" style="padding-right:10%">
                <button type="button" class="bmw-xs-results-btn-clear-filter" (click)='clearFilter()'>Clear Filter</button>
              </div>
              <div class="col-xs-6" style="padding-right:10%">
                <button type="button" class="bmw-xs-results-btn-apply-filter" (click)='applyFilter()'>Apply Filter</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="row bmw-no-gutter bmw-xs-results-label">
  <div class="col-xs-5 bmw-align-text-left" style="margin-right:-13px; padding-right:0px">
    Results per page
  </div>
  <div class="col-xs-7 bmw-no-gutter bmw-align-text-left">
    <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===5?"#1c69d4":"#333"' (click)='updateResultsLimit(5)'>5</a>
    <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===10?"#1c69d4":"#333"' (click)='updateResultsLimit(10)'>10</a>
    <a class="bmw-lg-results-display-count" [style.color]='resultsLimit===15?"#1c69d4":"#333"' (click)='updateResultsLimit(15)'>15</a>
  </div>
</div>
<app-results-content (resultsCount)='resultCountChange($event)' [resultsLimit]="resultsLimit" ></app-results-content>
</div>
</div>